<template>
  <div
    v-resize="setStickyStyleIfNeeded"
    class="search-form-header"
    :style="stickyStyle"
  >
    <div class="search-form-header--wrap">
      <div class="search-form-header--left">
        <Sort
          class="search-form-header__sort"
          :options="sortOptions"
          :selected-value="sortSelectedValue"
          @change-sort="onSelectSort"
        />
        <FilterModule
          class="search-form-header__filter"
          :filter-count="filterCount"
          @clicked="onClickFilter"
        />
      </div>
      <div class="search-form-header--right">
        <div class="search-form-header__counter">
          <div v-if="isLoading">
            <SmallLoading />
          </div>
          <p v-else class="search-form-header__counter--content">
            {{ totalCount }} 件
          </p>
        </div>
      </div>
    </div>
    <BudgetChips
      v-if="showBudgetChips"
      class="search-form-header__budget-chips"
      :lower-budget="lowerBudget"
      :higher-budget="higherBudget"
      @click-chip="onClickBudgetChip"
    />
  </div>
</template>
<script>
import BudgetChips from '../../../features/item-search/BudgetChips.vue'
import FilterModule from '../../atoms/filters/FilterModule.vue'
import Sort from '../../atoms/sorts/Sort.vue'
import SmallLoading from '../../atoms/loadings/SmallLoading.vue'

export default {
  components: {
    BudgetChips,
    FilterModule,
    Sort,
    SmallLoading
  },
  props: {
    filterCount: {
      type: Number,
      required: false,
      default: 0
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    sortOptions: {
      type: Array,
      required: true
    },
    sortSelectedValue: {
      type: String,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    },
    showBudgetChips: {
      type: Boolean,
      required: false,
      default: false
    },
    lowerBudget: {
      type: Number,
      required: false,
      default: null
    },
    higherBudget: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      stickyStyle: {}
    }
  },
  mounted() {
    this.setStickyStyleIfNeeded()
  },
  methods: {
    onClickFilter() {
      this.$emit('click-filter')
    },
    onClickBudgetChip(chip) {
      this.$emit('click-budget-chip', chip)
    },
    onSelectSort(event) {
      this.$emit('change-sort', event)
    },
    setStickyStyleIfNeeded() {
      const headers = document.querySelectorAll('header.header')
      if (headers.length !== 1) {
        return {}
      }
      const headerBottomRect = headers[0].getBoundingClientRect().bottom
      this.stickyStyle = {
        position: 'sticky',
        top: `${headerBottomRect}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  // 中のsortでscopeを使用している関係で見た目上の空白が生じている。
  // その空白が 9px で 当てたいmarginが 16px なので 16px - 9px で 7pxを設定。
  padding: 7px 16px;
  background-color: $white;
  z-index: 1;

  &--wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: $max-contents-width;
  }

  &--left {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 auto;
  }

  &__sort {
    margin-right: 12px;
  }

  &__budget-chips {
    margin: 16px 0 24px;
    width: 100%;
    max-width: $max-contents-width;
    box-sizing: border-box;
  }

  &--right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
  }

  &__counter {
    &--content {
      font-size: 16px;
      color: $gray-1;
    }
  }
}
</style>
